export default __webpack_public_path__ + "static/Entenda0018-c315155679a612a26b2be794c5858d74.jpg";